@if (config && control && group) {
  @if (config && control && group) {
    <form novalidate [id]="config.id || config.prop" [formGroup]="group">
      <fieldset
        role="radiogroup"
        [attr.aria-labelledby]="config.id || config.prop"
        [attr.readonly]="config.readonly ? config.readonly : null"
        [ngClass]="{
          FormControl__RadioGroup: config.inline === true,
        }"
      >
        @for (
          radioConfig of config.options;
          track radioConfig;
          let i = $index
        ) {
          <label
            class="form-control--radio__wrapper"
            [ngClass]="{
              'form-control--radio__wrapper--inline': config.inline === true,
              'form-control--radio__wrapper--justify':
                config.alignment === 'justified',
              'form-control--radio__wrapper--top-aligned':
                config.isTopAligned === true,
            }"
            [id]="(config.id || config.prop) + '_' + i"
          >
            @if (radioConfig.label && config.alignment === 'justified') {
              <p class="t-data" [innerHTML]="radioConfig.label"></p>
            }
            <input
              #radio
              class="form-control form-control--radio"
              role="radio"
              type="radio"
              [attr.disabled]="config.isDisabled ? config.isDisabled : null"
              [attr.readonly]="config.readonly ? config.readonly : null"
              [attr.name]="config.prop"
              [attr.checked]="control.value === radioConfig.value ? true : null"
              [value]="radioConfig.value"
              [formControlName]="config.prop"
              [attr.aria-checked]="control.value === !!radioConfig.value"
              [attr.aria-invalid]="
                (control.dirty || control.touched) && !control.valid
              "
              [attr.aria-describedby]="(config?.id || config?.prop) + '-label'"
              [attr.aria-errormessage]="
                'error_' + (config?.id || config?.prop) + '-input'
              "
              [attr.aria-labelledby]="(config.id || config.prop) + '_' + i"
            />
            @if (radioConfig.label && !config.alignment) {
              <p
                class="t-data RadioLabel"
                [ngClass]="{
                  'form-control--radio__label--unchecked':
                    control.value !== radioConfig.value && config.isDisabled,
                }"
              >
                @if (isArray(radioConfig.label)) {
                  @for (label of radioConfig.label; track label) {
                    <div class="RadioLabelItems">
                      <span
                        class="RadioLabelItems__Key t-bold"
                        [innerHTML]="label.key + ':'"
                      ></span>
                      @if (isArray(label.value)) {
                        @for (value of label.value; track value) {
                          <div class="RadioLabelItems__Value">
                            <span [innerHTML]="value"></span>
                          </div>
                        }
                      } @else {
                        <span
                          class="RadioLabelItems__Value"
                          [innerHTML]="label.value"
                        ></span>
                      }
                    </div>
                  }
                } @else {
                  <span [innerHTML]="radioConfig.label"></span>
                }
              </p>
            }
          </label>
        }
      </fieldset>
    </form>
  }
}
